import { render, staticRenderFns } from "./BVForm.vue?vue&type=template&id=91dbf22a&scoped=true"
import script from "./BVForm.vue?vue&type=script&lang=js"
export * from "./BVForm.vue?vue&type=script&lang=js"
import style0 from "./BVForm.vue?vue&type=style&index=0&id=91dbf22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dbf22a",
  null
  
)

export default component.exports